module.exports = __webpack_public_path__ + "img/portfolic-bg.a089d267.jpg";